import {
  defineComponent,
  ref,
} from 'vue';
import { VAutocomplete } from 'vuetify/components';
import { CLIENT_TO_DESIGNSYSTEM } from '@src/testpage/components/helpers/displayConfig.js';
import { wrapInSuspense } from '@src/testpage/components/helpers/wrapInSuspense.js';
import html from './MfeClientSelect.html'; // eslint-disable-line 

// Needs to be wrapped in <Suspense> because setup() is async
export const MfeClientSelect = wrapInSuspense(defineComponent({
  name: 'MfeClientSelect',
  components: {
    VAutocomplete,
  },
  template: html,
  props: {
    value: String,
  },
  emits: ['change'],
  setup(props) {
    const client = ref<string>(props.value!);
    const clients: Record<string, string>[] = Object.keys(CLIENT_TO_DESIGNSYSTEM).map((c) => ({ title: c, value: c }));
    return { clients, client };
  },
}));
